import React from 'react';
import { Link } from 'react-router-dom';
import Panel from '../../../common/layout/Panel';

const AccessManagement = () => {
    return (
        <Panel title="Access Management">
            <div className="p-6">
                <h2>Access Management Dashboard</h2>
                <p>Welcome to the access management system.</p>
                <div className="mt-4">
                    <Link to="/admin/access/groups" className="btn btn-primary mr-2">
                        Access Groups
                    </Link>
                    <Link to="/admin/access/areas" className="btn btn-primary mr-2">
                        Access Areas
                    </Link>
                    <Link to="/admin/access/rights" className="btn btn-primary mr-2">
                        Access Rights
                    </Link>
                    <Link to="/admin/access/rights/bulk-edit" className="btn btn-primary mr-2">
                        Bulk Rights
                    </Link>
                    <Link to="/admin/access/user-assignments" className="btn btn-primary">
                        User Assignments
                    </Link>
                </div>
            </div>
        </Panel>
    );
};

export default AccessManagement; 